class FreeShippingBar extends HTMLElement {
  constructor() {
    super();

    const baseLimit = Number(this.dataset.limit);

    // Shopify currency rate (for multi-currency)
    const rate = window.Shopify?.currency?.rate || 1;

    // Convert limit to current currency
    this.limit = baseLimit * rate;

    this.messageTemplate = this.dataset.messageTemplate;
    this.successMessage = this.dataset.successMessage;

    this.progressBar = this.querySelector('.free-shipping-progress');
    this.messageElement = this.querySelector('.free-shipping-text');
  }

  connectedCallback() {
    const savedWidth = sessionStorage.getItem('shipping_bar_width');

    if (savedWidth && this.progressBar) {
      this.progressBar.style.transition = 'none';
      this.progressBar.style.width = `${savedWidth}%`;

      void this.progressBar.offsetHeight;

      this.progressBar.style.transition = 'width 0.4s ease';
    }

    this.fetchCart();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.cartData) {
          this.update(event.cartData.total_price);
        } else {
          this.fetchCart();
        }
      });
    }
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  fetchCart() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = root === '/' ? '/cart.js' : root + 'cart.js';

    fetch(url)
      .then(response => response.json())
      .then(cart => {
        this.update(cart.total_price);
      })
      .catch(e => console.error("Error fetching cart:", e));
  }

  update(totalCents) {
    if (totalCents === undefined || totalCents === null) return;

    // Convert cents → currency
    const currentTotal = totalCents / 100;

    const remaining = Math.max(this.limit - currentTotal, 0);
    const percent = Math.min((currentTotal / this.limit) * 100, 100);

    if (this.progressBar) {
      sessionStorage.setItem('shipping_bar_width', percent);
      this.progressBar.style.width = `${percent}%`;
    }

    if (remaining <= 0) {
      if (this.messageElement) {
        this.messageElement.innerHTML = this.successMessage;
      }
      this.classList.add('is-success');
    } else {
      this.classList.remove('is-success');

      const formattedAmount = this.formatMoney(remaining);

      const message = this.messageTemplate.replace(
        /\{\{\s*amount\s*\}\}/gi,
        formattedAmount
      );

      if (this.messageElement) {
        this.messageElement.innerHTML = message;
      }
    }
  }

  // Proper Shopify money formatting
  formatMoney(amount) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(
        amount * 100,
        Shopify.money_format // ✅ ensures symbol
      );
    }

    // fallback
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(amount);
  }
}

customElements.define('free-shipping-bar', FreeShippingBar);